import { useState } from "react";

function AiAssistant() {
  const [open, setOpen] = useState(false);

  return (
    <div className="ai-assistant">
      {open && (
        <div className="ai-chat-modal">
          <div className="ai-chat-header">
            <span>Bongo Games Assistant</span>
            <button type="button" className="ai-chat-close" onClick={() => setOpen(false)}>
              &times;
            </button>
          </div>
          <iframe
            src="https://app.autofaya.com/chat/chat_614b61e2c00daaa23b39a49b"
            width="420"
            height="640"
            style={{ border: 0, borderRadius: "0 0 8px 8px" }}
            title="Bongo games Assistant"
          />
        </div>
      )}
      <button
        type="button"
        className={`ai-float-btn ${open ? "ai-float-active" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
        aria-label={open ? "Close AI assistant" : "Open AI assistant"}
      >
        {open ? (
          <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" />
            <circle cx="12" cy="10" r="1.2" />
            <circle cx="8" cy="10" r="1.2" />
            <circle cx="16" cy="10" r="1.2" />
          </svg>
        )}
      </button>
    </div>
  );
}

export default AiAssistant;
